import createVueComponent from '../createVueComponent';

const Link2 = createVueComponent('Link2Icon', [
  ['path', { d: 'M15 7h2a5 5 0 010 10h-2m-6 0H7A5 5 0 017 7h2' }],
  ['line', { x1: '8', y1: '12', x2: '16', y2: '12' }],
]);

export default Link2;
